import React from "react";
import "./Advertisement.css";

const Advertisement = () => {
  return (
    <section className="ad-section">
      <div className="ad-card no-image">
        <div className="ad-info">
          {/* Animated Gradient Heading */}
          <h2 className="animated-heading">Great Opportunity for All!</h2>

          {/* Typing Animated Subtext */}
          <p className="typing-text">
            🚀 100% Job Placement | Guaranteed Career Boost | Limited Seats Only
          </p>

          <p>
            Quick Career Launch: <b>1-Month Training + Assured Placement</b>{" "}
            with
            <b> Capgemini Certification</b>. Your dream career starts here!
          </p>

          <h3 className="salary">💰 Salary: 30k - 60k / Month</h3>

          <div className="courses-grid">
            <div>
              <p>Banking</p>
              <p>Finance</p>
              <p>H.R</p>
              <p>C.R.M</p>
            </div>
            <div>
              <p>BPO Voice & Non Voice</p>
              <p>Accounts</p>
              <p>B.D.E</p>
              <p>Digital Marketing</p>
            </div>
          </div>

          <div className="ad-buttons">
            <button className="apply-btn">
              <a href="/contact">Apply Now</a>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Advertisement;
